var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "m-tab-bar",
    _vm._g(
      _vm._b({ staticClass: "tabs" }, "m-tab-bar", _vm.$attrs, false),
      _vm.$listeners
    ),
    _vm._l(_vm.tabs, function(tab) {
      return _c(
        "m-tab",
        {
          key: tab.title,
          attrs: { href: tab.title, "min-width": true },
          model: {
            value: _vm.alwaysActive,
            callback: function($$v) {
              _vm.alwaysActive = $$v
            },
            expression: "alwaysActive"
          }
        },
        [
          tab.icon
            ? _c("m-icon", {
                attrs: { slot: "icon", icon: tab.icon },
                slot: "icon"
              })
            : _vm._e(),
          _vm._v("\n    " + _vm._s(tab.title) + "\n  ")
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }